import { Perpetrator, UpdateReport } from 'src/api';

export const deleteEvent = async (
  eventID: string,
  currentReport: UpdateReport,
  updateReport: (reportID: string, report: UpdateReport) => Promise<void>,
) => {
  const newEvents =
    currentReport.evidence?.events.filter((event) => event.id !== eventID) ??
    [];
  const newEvidence =
    currentReport.evidence?.evidence.filter((e) => e.event !== eventID) ?? [];
  const updatedPerpetrators = newEvidence
    .filter((e) => e.type === '@evidence/perpetrator')
    .map((e) => e.value);
  await updateReport(currentReport?.report ?? '', {
    ...currentReport,
    perpetrators: updatedPerpetrators as Perpetrator[],
    evidence: {
      events: newEvents,
      evidence: newEvidence,
    },
  });
};
